import { gql, useSuspenseQuery } from '@apollo/client';
import { useLocation } from 'react-use';

import { BasicAddressWithTimezoneFragment, IBasicAddressWithTimezone } from '../../utils/addresses';

export type AddressForVisitBookingFlow = IBasicAddressWithTimezone & {
    coordinates: { latitude: string; longitude: string } | null;
};

const ADDRESS_FOR_VISIT_BOOKING_FLOW_QUERY = gql`
    query AddressForVisitBookingFlow($id: UUID!) {
        address(id: $id) {
            ...BasicAddressWithTimezoneFragment
            coordinates {
                latitude
                longitude
            }
        }
    }
    ${BasicAddressWithTimezoneFragment}
`;

type AddressForVisitBookingFlowQueryType = {
    address: AddressForVisitBookingFlow | null;
};

export const useAddressForVisitBookingFlow = (): AddressForVisitBookingFlow | null => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const addressId = params.get('addressId');
    const { data } = useSuspenseQuery<AddressForVisitBookingFlowQueryType>(
        ADDRESS_FOR_VISIT_BOOKING_FLOW_QUERY,
        {
            skip: !addressId,
            variables: { id: addressId },
        },
    );
    return data?.address ?? null;
};
